import { useTranslation } from '../../i18n';
import { FormField } from './FormField';
import { formFieldInputClassName } from './formFieldStyles';
import { getSalutationOptions, isSalutation, type Salutation } from '../../utils/salutation';

interface SalutationSelectProps {
  value: Salutation | null | undefined;
  onChange: (value: Salutation | null) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

/** Themed salutation dropdown; option '' = not specified (maps to null). */
export function SalutationSelect({
  value,
  onChange,
  label,
  disabled,
  className = '',
}: SalutationSelectProps) {
  const { t } = useTranslation(['common']);
  const options = getSalutationOptions(t);
  const resolvedLabel = label ?? t('common:salutation.label');

  return (
    <FormField label={resolvedLabel}>
      <select
        // why: FormField renders its label as a sibling without htmlFor, so the
        // select needs its own accessible name.
        aria-label={resolvedLabel}
        value={isSalutation(value) ? value : ''}
        onChange={(e) => onChange(isSalutation(e.target.value) ? e.target.value : null)}
        disabled={disabled}
        className={formFieldInputClassName(false, className)}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </FormField>
  );
}

SalutationSelect.displayName = 'SalutationSelect';
